import { renderToString } from 'react-dom/server';
import { generateOrganizationSchema, generateWebSiteSchema } from './organization';

/**
 * Generate FAQPage schema for FAQ category pages
 * @param {Array} faqContent - Array of FAQ items with question and answers
 * @param {string} categorySlug - Category slug (e.g., 'for-buyers')
 * @param {string} categoryLabel - Category label (e.g., 'For Buyers')
 * @returns {Object} JSON-LD schema object
 */
export function generateFAQPageSchema(faqContent, categorySlug, categoryLabel) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      generateOrganizationSchema(),
      generateWebSiteSchema(),
      {
        '@type': 'FAQPage',
        '@id': `https://www.realestateagents.com/faq/${categorySlug}#faqpage`,
        url: `https://www.realestateagents.com/faq/${categorySlug}`,
        name: `Frequently Asked Questions ${categoryLabel} | RealEstateAgents.com`,
        inLanguage: 'en-US',
        isPartOf: {
          '@type': 'WebSite',
          '@id': 'https://www.realestateagents.com/#website',
        },
        publisher: {
          '@id': 'https://www.realestateagents.com/#organization',
        },
        mainEntity: faqContent.map((content) => ({
          '@type': 'Question',
          name: content.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: renderToString(content.answers),
          },
        })),
        breadcrumb: {
          '@id': `https://www.realestateagents.com/faq/${categorySlug}#breadcrumb`,
        },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `https://www.realestateagents.com/faq/${categorySlug}#breadcrumb`,
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: 'https://www.realestateagents.com/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'FAQ',
            item: 'https://www.realestateagents.com/faq',
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: categoryLabel,
            item: `https://www.realestateagents.com/faq/${categorySlug}`,
          },
        ],
      },
    ],
  };
}

/**
 * Generate CollectionPage schema for FAQ hub page
 * @param {string} description - Page description
 * @returns {Object} JSON-LD schema object
 */
export function generateFAQHubSchema(description) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      generateOrganizationSchema(),
      generateWebSiteSchema(),
      {
        '@type': 'CollectionPage',
        '@id': 'https://www.realestateagents.com/faq#webpage',
        url: 'https://www.realestateagents.com/faq',
        name: 'Frequently Asked Questions (FAQ) | RealEstateAgents.com',
        description,
        inLanguage: 'en-US',
        isPartOf: {
          '@type': 'WebSite',
          '@id': 'https://www.realestateagents.com/#website',
        },
        publisher: {
          '@id': 'https://www.realestateagents.com/#organization',
        },
        breadcrumb: {
          '@id': 'https://www.realestateagents.com/faq#breadcrumb',
        },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': 'https://www.realestateagents.com/faq#breadcrumb',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: 'https://www.realestateagents.com/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'FAQ',
            item: 'https://www.realestateagents.com/faq',
          },
        ],
      },
    ],
  };
}
